<template>
	<div class="panel panel-primary panel-border top mt30" >
		<div class="panel-body p10">
			<div class="list-group list-group-links list-group-spacing-xs mbn">
				<table class="table">
					<thead>
						<tr>
							<th id="transactionDetails">
								Transaction Details
							</th>
							<th>
								Date / Time
							</th>
							<th width="75">
								Amount
							</th>
							<th>
								Status
							</th>
						</tr>
					</thead>
					<tbody v-for="transaction in transactions">
						<tr v-for="(history, i) in transaction.statusHistory" v-if="transaction.payment_gateway_id == 1">
							<td :rowspan="transaction.statusHistory.length" v-if="i == 0">
								<div class="d-flex flex-column flex-fill">
									<div class="d-flex flex-fill justify-content-center"><div class="text-right mr-2"><strong>Id:</strong></div> <div>{{ !transaction.id ? '' : transaction.id }}</div></div>
									<div class="d-flex flex-fill justify-content-center"><div class="text-right mr-2"><strong>Type:</strong></div> <div>{{ !transaction.type ? '' : transaction.type }}</div></div>
								</div>

								<div class="d-flex flex-fill pt-3" v-if="transaction.type == 'sale' && transaction.status == 'settled' && !transaction.refundId ">
									<div><button class="btn btn-small btn-danger" @click.prevent="voidOrRefund(transaction.id)">Refund</button></div>
									<div><input id="refund-amount" type="number" class="input-mini form-control" :value="transaction.amount"></div>
								</div>
								<div v-else-if="transaction.status == 'submitted_for_settlement'">
									<div class="pt-3"><button class="btn btn-small btn-danger" @click.prevent="voidOrRefund(transaction.id)">Void</button></div>
								</div>
							</td>

							<td>{{ moment.utc(history.timestamp.date).tz(timezone).format('YYYY-MM-DD hh:mm:s a') }}</td>
							<td>{{ history.amount }}</td>
							<td>{{ history.status }}</td>
						</tr>
						<tr v-if="transaction.payment_gateway_id == 2">
							<td>
								<strong>Id:</strong> {{ !transaction.id ? '' : transaction.id }}<br/>
								<strong>Type:</strong> {{ !transaction.type ? '' : transaction.type }}<br/>

								<div class="d-flex flex-fill pt-3" v-if="transaction.type == 'charge' && (transaction.amount - transaction.amountRefunded) > 0">
									<div><button v-if="false" class="btn btn-small btn-danger" @click.prevent="voidOrRefund(transaction.id)">Refund</button></div>
									<div><input  v-if="false" id="refund-amount" type="number" class="input-mini form-control" :value="(transaction.amount - transaction.amountRefunded)"></div>
								</div>
							</td>
							<td>{{ moment.utc(transaction.created_at).tz(timezone).format('YYYY-MM-DD hh:mm:s a') }} </td>
							<td>{{ transaction.amount }}</td>
							<td>{{ transaction.status }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			transactions: Array,
			timezone: String,
			refundAmount: 0
		},
		components: {
	
		},
		methods: {
			voidOrRefund: function(transactionId) {
				if( !confirm('Are you sure you would like to void/refund this transaction?') ) {
					return false;
				}
				
				var refundAmount = $('#refund-amount').val();

				let transaction = this.transactions.find(x => x.id === transactionId);
				if( transaction ) {
					axios.post(`/transactions/voidOrRefundTransaction/${transactionId}`, {orderId: transaction.order_id, admin_partner_id: transaction.partner_id, refundAmount: refundAmount}).then(response => {
						this.success_msg = 'Transaction was voided/refunded successfully.';
						window.location.reload();
					}).catch(error => {
						this.error_msg = error;
					});
				} else {
					this.error_msg = 'Something went wrong.';
				}
			},
		},
	}
</script>